import { render, staticRenderFns } from "./term-status-history-popover.vue?vue&type=template&id=6fa38b3c&"
import script from "./term-status-history-popover.vue?vue&type=script&lang=js&"
export * from "./term-status-history-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports